module.exports = __webpack_public_path__ + "static/illustrazione-capitolo-1-6ca65804ea08f1d7600f0a9f42f2d5e1.svg";